import { render, staticRenderFns } from "./CaasQueue.vue?vue&type=template&id=181a9010&scoped=true&"
import script from "./CaasQueue.vue?vue&type=script&lang=js&"
export * from "./CaasQueue.vue?vue&type=script&lang=js&"
import style0 from "./CaasQueue.vue?vue&type=style&index=0&id=181a9010&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181a9010",
  null
  
)

export default component.exports